import { useStyles } from "./Videos.style";
import { useState, useEffect } from "react";
import VideoCard from "../../components/common/VideoCard/VideoCard";
import { TabsList } from "../../components/common/TabsList";
import { useQuery, useMutation } from "@apollo/client";
import {
  contentVideosGQL,
  VideoItem,
  VideoType,
  startContentViewGQL,
  completeContentViewGQL,
  UserContentType,
} from "@onmo/graphql/graphql";
import LaunchPad from "../../components/common/ServiceSelection/LaunchPad";

const channelByCategory = [
  { category: "Gaming", title: "tab_Gaming" },
  {
    category: "Race & Chase",
    title: "tab_Race & Chase",
    channelId: "UC2pdmlMIATaSfaxNuRTL4OA",
  },
  {
    category: "Sports",
    title: "tab_Sports",
    channelId: "UCoyaxd5LQSuP4ChkxK0pnZQ",
  },
  {
    category: "Puzzle",
    title: "tab_Puzzle",
    channelId: "UCyXWYhbJomJcTUg98MR5PFA",
  },
];

const Videos: React.FC = () => {
  const classes = useStyles();
  const [playingVideoId, setPlayingVideoId] = useState<string>();
  const [activeChannel, setActiveChannel] = useState(channelByCategory[0]);
  const [contentViewId, setContentViewId] = useState(null);
  const { data: videosData } = useQuery(contentVideosGQL, {
    variables: {
      type: VideoType.Youtube,
      params: { maxResults: 50, channelId: activeChannel.channelId },
    },
  });
  const [startContentView] = useMutation(startContentViewGQL);
  const [completeContentView] = useMutation(completeContentViewGQL);

  const onChangeTab = (title: string) => {
    const selectedTab = channelByCategory.find((tab) => tab.title === title);
    if (selectedTab) {
      setActiveChannel(selectedTab);
    }
  };

  const onPlayVideo = async (videoId: string) => {
    setPlayingVideoId(videoId);
    const contentView = await startContentView({
      variables: {
        input: {
          contentType: UserContentType.Video,
        },
      },
    });
    setContentViewId(contentView?.data?.startContentView?.contentId);
  };

  useEffect(() => {
    return () => {
      if (contentViewId) {
        completeContentView({
          variables: {
            input: {
              contentId: contentViewId,
            },
          },
        });
      }
    };
  }, [contentViewId, completeContentView]);

  return (
    <div className={classes.root}>
      <LaunchPad />
      <div className={classes.container}>
        <TabsList
          listTabs={channelByCategory.map((item) => item.title)}
          onChangeTab={onChangeTab}
          activeTab={activeChannel.title}
          tabVariant="contained"
          className={classes.tabs}
        />
        <div className={classes.videoList}>
          {(videosData?.contentVideos || [])?.map((video: VideoItem) => (
            <VideoCard
              video={video}
              onClick={() => onPlayVideo(video.id)}
              isPlayingVideo={video.id === playingVideoId}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Videos;
